import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {Link as RouterLink, useParams} from "react-router-dom";
import {chartImplementationListRoute, dashboardBaseRoute, dashboardListRoute,} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import DashBoardCreateUpdateForm from "../DashBoardAddView/DashBoardCreateUpdateForm";

const DashBoardDetailsView = () => {
    const {currentBrand} = useAuth()

    let {dashboardId} = useParams();


    const searchParams = new URLSearchParams(window.location.search);
    const urlBack = searchParams.get('urlBack');
    const urlBackTitle = searchParams.get('urlBackTitle');


    function getMainButtons() {
        return (
            <>
                {urlBack && urlBackTitle &&
                    <RouterLink to={decodeURI(urlBack)}
                                style={{ textDecoration: 'none' }}
                    >
                        <Button
                            color="primary"
                            variant="contained"
                            startIcon={(
                                <SvgIcon>
                                    <ArrowBackIcon />
                                </SvgIcon>
                            )}
                        >
                            {urlBackTitle}
                        </Button>
                    </RouterLink>
                }
                <RouterLink to={'/' + dashboardBaseRoute + '/' + dashboardListRoute}
                            style={{ textDecoration: 'none' }}
                >
                    <Button
                        color="primary"
                        variant="contained"
                        startIcon={(
                            <SvgIcon>
                                <ArrowBackIcon />
                            </SvgIcon>
                        )}
                    >
                        {localStrings.backToList}
                    </Button>
                </RouterLink>
            </>
        )
    }

    return (
        <PageWithTitle title={localStrings.chartImplementation} mainButtons={getMainButtons()}>
            <DashBoardCreateUpdateForm modeEdit={MODE_EDIT}/>
        </PageWithTitle>
    );
};

export default DashBoardDetailsView;
